import React from "react";
import classNames from "classnames/bind";
import styles from "./authorization.module.scss";

const cx = classNames.bind(styles);

interface PasswordStrengthBarProps {
  strength: number;
  strengthColor: string;
  strengthText: string;
}

export const PasswordStrengthBar: React.FC<PasswordStrengthBarProps> = ({
  strength,
  strengthColor,
  strengthText,
}) => (
  <div className={cx('passwordStrength')}>
    <div className={cx('passwordStrengthBar')}>
      {[1, 2, 3, 4, 5].map((level) => (
        <div
          key={level}
          className={cx('passwordStrengthSegment')}
          style={{
            backgroundColor: level <= strength ? strengthColor : "#e8e8e8",
          }}
        />
      ))}
    </div>
    <span className={cx('passwordStrengthText')} style={{ color: strengthColor }}>
      {strengthText}
    </span>
  </div>
);
